var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { fluid: "", "grid-list-md": "" } },
    [
      _c(
        "v-tabs",
        { attrs: { left: "", color: "transparent" } },
        [_c("v-tab", [_vm._v("Cotizaciones")])],
        1
      ),
      _c("v-divider"),
      _c(
        "v-dialog",
        {
          attrs: { width: "500" },
          model: {
            value: _vm.showInfoDialog,
            callback: function($$v) {
              _vm.showInfoDialog = $$v
            },
            expression: "showInfoDialog"
          }
        },
        [
          _c(
            "v-toolbar",
            { attrs: { dark: "", color: "primary" } },
            [
              _c(
                "v-toolbar-title",
                {
                  staticStyle: {
                    "font-size": "17px",
                    "margin-left": "10px !important"
                  }
                },
                [_vm._v("Cotizaciones Generadas")]
              )
            ],
            1
          ),
          _c("v-divider"),
          _c(
            "v-card",
            { attrs: { "max-height": "300", id: "bodyDialogInfo" } },
            [
              _c(
                "div",
                {
                  staticStyle: { "margin-left": "20px", "margin-top": "20px" }
                },
                _vm._l(_vm.infoItems, function(item) {
                  return _c(
                    "div",
                    { key: item.index, staticClass: "itemInfoDiv" },
                    [
                      _c(
                        "li",
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: { small: "", icon: "" },
                              on: {
                                click: function($event) {
                                  return _vm.PDFContacto(item.pdf)
                                }
                              }
                            },
                            [
                              _c(
                                "v-icon",
                                { attrs: { small: "", color: "#526da5" } },
                                [_vm._v("picture_as_pdf")]
                              )
                            ],
                            1
                          ),
                          _c(
                            "strong",
                            {
                              staticStyle: { cursor: "pointer" },
                              on: {
                                click: function($event) {
                                  return _vm.PDFContacto(item.pdf)
                                }
                              }
                            },
                            [
                              _vm._v(
                                "PDF de " +
                                  _vm._s(item.Contacto) +
                                  "\n            "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ]
                  )
                }),
                0
              )
            ]
          )
        ],
        1
      ),
      _c("br"),
      _c("br"),
      _c(
        "v-flex",
        { attrs: { sm12: "", md12: "", layout: "", wrap: "" } },
        [
          _c(
            "v-flex",
            { attrs: { sm12: "", md12: "", layout: "", wrap: "" } },
            [
              _c(
                "v-flex",
                { attrs: { sm2: "", md2: "" } },
                [
                  _c("v-autocomplete", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      }
                    ],
                    attrs: {
                      label: _vm.formFields.ejecutivo.label,
                      items: _vm.ejecutivosList,
                      "item-text": "nombre",
                      "item-value": "id",
                      "error-messages": _vm.errors.collect("ejeVal"),
                      "data-vv-name": "ejeVal",
                      disabled: _vm.currentEjecutivo.isleader == "f",
                      clearable: _vm.currentEjecutivo.isleader != "f",
                      required: ""
                    },
                    on: {
                      change: function($event) {
                        return _vm.clearAutocomplete("ejecutivo")
                      }
                    },
                    model: {
                      value: _vm.formFields.ejecutivo.value,
                      callback: function($$v) {
                        _vm.$set(_vm.formFields.ejecutivo, "value", $$v)
                      },
                      expression: "formFields.ejecutivo.value"
                    }
                  })
                ],
                1
              ),
              _c(
                "v-flex",
                { attrs: { sm2: "", md2: "" } },
                [
                  _c("v-autocomplete", {
                    attrs: {
                      label: _vm.formFields.razon_social.label,
                      items: _vm.razonSocialList,
                      "item-text": "razon_social",
                      "item-value": "razon_social",
                      clearable: "",
                      required: ""
                    },
                    on: {
                      change: function($event) {
                        return _vm.clearAutocomplete("razon_social")
                      }
                    },
                    model: {
                      value: _vm.formFields.razon_social.value,
                      callback: function($$v) {
                        _vm.$set(_vm.formFields.razon_social, "value", $$v)
                      },
                      expression: "formFields.razon_social.value"
                    }
                  })
                ],
                1
              ),
              _c(
                "v-flex",
                { attrs: { sm2: "", md1: "" } },
                [
                  _c("v-autocomplete", {
                    attrs: {
                      label: _vm.formFields.cotizacion.label,
                      items: _vm.cotizacionesList,
                      "item-text": "id",
                      "item-value": "id",
                      clearable: "",
                      required: ""
                    },
                    on: {
                      change: function($event) {
                        return _vm.clearAutocomplete("cotizacion")
                      }
                    },
                    model: {
                      value: _vm.formFields.cotizacion.value,
                      callback: function($$v) {
                        _vm.$set(_vm.formFields.cotizacion, "value", $$v)
                      },
                      expression: "formFields.cotizacion.value"
                    }
                  })
                ],
                1
              ),
              _c(
                "v-flex",
                { attrs: { sm2: "", md1: "" } },
                [
                  _c("v-autocomplete", {
                    attrs: {
                      label: _vm.formFields.estado.label,
                      items: _vm.estadosList,
                      "item-text": "estado",
                      "item-value": "estado",
                      clearable: "",
                      required: ""
                    },
                    on: {
                      change: function($event) {
                        return _vm.clearAutocomplete("estado")
                      }
                    },
                    model: {
                      value: _vm.formFields.estado.value,
                      callback: function($$v) {
                        _vm.$set(_vm.formFields.estado, "value", $$v)
                      },
                      expression: "formFields.estado.value"
                    }
                  })
                ],
                1
              ),
              _c(
                "v-flex",
                { attrs: { sm2: "", md2: "" } },
                [
                  _c("DatePicker", {
                    attrs: {
                      label: _vm.formFields.fechaInicio.label,
                      "error-messages": _vm.errors.collect(
                        _vm.formFields.fechaInicio.id
                      ),
                      id: _vm.formFields.fechaInicio.id,
                      max: _vm.formFields.fechaInicio.maxDate.format(
                        "YYYY-MM-DD"
                      )
                    },
                    model: {
                      value: _vm.formFields.fechaInicio.value,
                      callback: function($$v) {
                        _vm.$set(_vm.formFields.fechaInicio, "value", $$v)
                      },
                      expression: "formFields.fechaInicio.value"
                    }
                  })
                ],
                1
              ),
              _c(
                "v-flex",
                { attrs: { sm2: "", md2: "" } },
                [
                  _c("DatePicker", {
                    attrs: {
                      label: _vm.formFields.fechaFin.label,
                      "error-messages": _vm.errors.collect(
                        _vm.formFields.fechaFin.id
                      ),
                      id: _vm.formFields.fechaFin.id,
                      max: _vm.formFields.fechaFin.maxDate.format("YYYY-MM-DD")
                    },
                    model: {
                      value: _vm.formFields.fechaFin.value,
                      callback: function($$v) {
                        _vm.$set(_vm.formFields.fechaFin, "value", $$v)
                      },
                      expression: "formFields.fechaFin.value"
                    }
                  })
                ],
                1
              ),
              _c("v-flex", { attrs: { sm2: "", md2: "" } }, [
                _c(
                  "div",
                  { staticClass: "text-sm-center botones-filtros" },
                  [
                    _c(
                      "v-btn",
                      { on: { click: _vm.handleBuscarClick } },
                      [
                        _c("v-icon", [_vm._v("search")]),
                        _vm._v("\n            Filtrar\n          ")
                      ],
                      1
                    ),
                    _c(
                      "v-btn",
                      { on: { click: _vm.clearFilters } },
                      [
                        _c("v-icon", [_vm._v("clear")]),
                        _vm._v("\n            Limpiar\n          ")
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _c("v-flex", { attrs: { xs12: "", sm5: "", md5: "" } }, [
        _c(
          "div",
          { attrs: { align: "left" } },
          [
            _c("v-text-field", {
              attrs: {
                "append-icon": "search",
                label: "Buscar...",
                "single-line": "",
                "hide-details": ""
              },
              on: { input: _vm.searchData },
              model: {
                value: _vm.search,
                callback: function($$v) {
                  _vm.search = $$v
                },
                expression: "search"
              }
            })
          ],
          1
        )
      ]),
      _c(
        "div",
        {
          staticClass: "right",
          staticStyle: { display: "flex", "margin-top": "-50px" }
        },
        [
          _c(
            "v-btn",
            {
              attrs: {
                id: "btnExportCsv",
                flat: "",
                small: "",
                color: "primary"
              },
              on: { click: _vm.onBtnExport }
            },
            [
              _c("v-icon", { staticClass: "importExportBtnIcon" }, [
                _vm._v("cloud_download ")
              ]),
              _vm._v("  \n      "),
              _c("span", { staticClass: "importExportBtnTexto" }, [
                _vm._v("Exportar CSV")
              ])
            ],
            1
          ),
          _c(
            "v-btn",
            {
              staticStyle: { height: "48px" },
              attrs: { color: "#ffe800" },
              on: {
                click: function($event) {
                  return _vm.handleModal("create")
                }
              }
            },
            [
              _c(
                "v-icon",
                {
                  staticStyle: {
                    "font-size": "160%",
                    "margin-right": "7% !important"
                  },
                  attrs: { dark: "", left: "" }
                },
                [_vm._v("add_circle_outline\n      ")]
              ),
              _c("span", [_vm._v("Nueva Cotización")])
            ],
            1
          )
        ],
        1
      ),
      _c("Datatable", { attrs: { headers: _vm.headers } }),
      _vm.dialog
        ? _c("CotizacionModal", {
            attrs: { tipo: _vm.tipo_modal, idToEdit: _vm.idToEdit },
            on: { cerrarCrear: _vm.handleCierreModalCrear }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }